import React from 'react';
import { DocumentFormContainerProps, DocumentFormViewProps } from './documentFormProps';
import { ReportingContainerBaseConfig } from '../../../base';
import {
    DocumentFormController,
    DocumentFormLoader,
    DocumentFormStateProvider,
} from './documentFormInterface';

export function createDocumentFormContainer(
    config: ReportingContainerBaseConfig,

    loader: DocumentFormLoader,
    controller: DocumentFormController,
    View: React.FC<DocumentFormViewProps>
): React.FC<DocumentFormContainerProps> {
    const {
        kernel: {},
        state: states,
        context: { useContext },
    } = config;

    return states.form.subscribe((containerProps) => {
        const context = useContext();
        const state = states.form.useState(context);
        const data = loader.useLoad(context, {
            document: {
                id: containerProps.document.id,
            },
            form: {
                id: containerProps.form.id,
            },
        });
        const props = controller.useProps(context, data, {
            tab: {
                value: state.value.tab,
                onChange(value) {
                    state.onChange({
                        tab: value,
                    });
                },
            },
        });
        return <View {...props} />;
    });
}
